export var frontViewDataSkeleton = [{
  sectionLetter: 'A',
  sectionProperty: 'Total height',
  sectionId: 'height',
  size: null
}, {
  sectionLetter: 'B',
  sectionProperty: 'Total width',
  sectionId: 'width',
  size: null
}, {
  sectionLetter: 'D',
  sectionProperty: 'Seat height',
  sectionId: 'seatHeight',
  size: null
}, {
  sectionLetter: 'F',
  sectionProperty: 'Seating area width',
  sectionId: 'seatingAreaWidth',
  size: null
}, {
  sectionLetter: 'G',
  sectionProperty: 'Arm rest height',
  sectionId: 'armRestHeight',
  size: null
}, {
  sectionLetter: 'H',
  sectionProperty: 'Arm rest width',
  sectionId: 'armRestWidth',
  size: null
}, {
  sectionLetter: 'K',
  sectionProperty: 'Seat back height',
  sectionId: 'seatBackHeight',
  size: null
}, {
  sectionLetter: 'M',
  sectionProperty: 'Longer width',
  sectionId: 'longerWidth',
  size: null
}, {
  sectionLetter: 'N',
  sectionProperty: 'Longer seating width',
  sectionId: 'longerSeatingWidth',
  size: null
}, {
  sectionLetter: 'O',
  sectionProperty: 'Shorter width',
  sectionId: 'shorterWidth',
  size: null
}, {
  sectionLetter: 'P',
  sectionProperty: 'Shorter seating width',
  sectionId: 'shorterSeatingWidth',
  size: null
}];
export var sideViewDataSkeleton = [{
  sectionLetter: 'C',
  sectionProperty: 'Total depth',
  sectionId: 'depth',
  size: null
}, {
  sectionLetter: 'E',
  sectionProperty: 'Seat depth',
  sectionId: 'seatDepth',
  size: null
}, {
  sectionLetter: 'I',
  sectionProperty: 'Frame height',
  sectionId: 'frameHeight',
  size: null
}, {
  sectionLetter: 'J',
  sectionProperty: 'Leg height',
  sectionId: 'legHeight',
  size: null
}, {
  sectionLetter: 'L',
  sectionProperty: 'Total depth',
  sectionId: 'totalDepth',
  size: null
}, {
  sectionLetter: 'Q',
  sectionProperty: 'Mattress Width',
  sectionId: 'mattressWidth',
  size: null
}, {
  sectionLetter: 'R',
  sectionProperty: 'Mattress Length',
  sectionId: 'mattressLength',
  size: null
}, {
  sectionLetter: 'S',
  sectionProperty: 'Mattress height from floor',
  sectionId: 'mattressHeightFromFloor',
  size: null
}, {
  sectionLetter: 'T',
  sectionProperty: 'Mattress depth',
  sectionId: 'mattressDepth',
  size: null
}];